import CreateProjectForm from "../../components/CreateProjectForm";
import DashboardLayout from "../../components/layouts/DashboardLayout";


const Project = ()=>{
    return <>
    <DashboardLayout>
   <h1>Gestion des projets</h1>
    <div className="py-6 my-6">
     <CreateProjectForm/>
    </div>
    </DashboardLayout>
    </>
    
}




export default Project;